import React from "react";

function ModalTechnologies({ skills }) {
  return skills.map((skill) => (
    <div key={skill.name} className="dev-skill">
      <img src={require(`../../assets/logos/${skill.icon}`)} alt={skill.name} />
      <h4>{skill.name}</h4>
    </div>
  ));
}

export default ModalTechnologies;
